import { Flex } from '@chakra-ui/react';
import { NestedArea } from '@habity/types';
import { Link } from '@chakra-ui/next-js';
import { AreaCardData } from './components/AreaCardData';
import { AreaImageCard } from './components/AreaImageCard';

interface AreaCardProps {
  area: NestedArea;
  href: string;
  isLoading?: boolean;
  variant?: 'default' | 'compact';
}

export const AreaCard = ({
  area,
  isLoading = false,
  href,
  variant = 'default',
}: AreaCardProps) => {
  // Create the card content
  const cardContent = (
    <Flex
      overflow="hidden"
      flexDirection={variant === 'compact' ? 'row' : 'column'}
      flexGrow={{ base: 0, sm: 1 }}
      justifyContent="flex-start"
      gap="1"
      minW="260px"
      cursor={isLoading ? 'default' : 'pointer'}
      border="none"
      className="group"
    >
      <AreaImageCard
        area={area}
        aspectRatio={1 / 1.2}
        borderTopRadius="4px"
        borderBottomRadius="4px"
        boxProps={{ cursor: isLoading ? 'default' : 'pointer' }}
        isLoading={isLoading}
      />
      <AreaCardData
        area={area}
        isLoading={isLoading}
        variant={variant}
      />
    </Flex>
  );

  // If loading, don't wrap with Link to make it not clickable
  if (isLoading) {
    return cardContent;
  }

  // Otherwise, wrap with Link for navigation
  return (
    <Link
      href={href}
      _hover={{ textDecoration: 'none' }}
      onClick={(e) => {
        // Check if the click is on or inside a button element
        const target = e.target as HTMLElement;
        if (target.closest('button')) {
          e.preventDefault();
          return;
        }
      }}
    >
      {cardContent}
    </Link>
  );
};
